import React from "react";
import "./style.css";

function Header () {
    return (
        <div className="header">
            <h1>Nick's Personal Portfolio</h1>
        </div>    
    )
}

export default Header;